import React, { useState } from "react";
import { Link, Outlet, useMatch } from "react-router-dom";
import { Layout } from "antd";
import { useResizeDetector } from "react-resize-detector";
import { useQueryParam, StringParam, BooleanParam } from "use-query-params";

const { Content, Sider } = Layout;

export const useNoLayout = (): boolean => {
  const [nolayout = false] = useQueryParam("nolayout", BooleanParam);

  return !!nolayout;
};

const MenuButton = ({ text, icon, link }) => {
  const match = useMatch(link);
  return (
    <Link to={link}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          color: match ? "#1890ff" : "black",
        }}
      >
        {React.createElement(icon, { style: { fontSize: 20, marginRight: 10 } })}
        {<span>{text}</span>}
      </div>
    </Link>
  );
};
const AppLayout = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
      }}
    >
      <Layout.Header style={{ background: "white", fontFamily: "Raleway" }}>
        <h2>Centre d’Écologie Urbaine – Analyse comparative des diagnostics des Plans d’action climat en RBC</h2>
      </Layout.Header>
      <Layout
        style={{
          transform: `scale(1)`,
          width: "100vw",
        }}
      >
        <Content
          style={{
            width: "100vw",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </div>
  );
};

export default AppLayout;
